// src/components/ServiceDetailsSection.js
function ServiceDetailsSection() {
  const serviceDetails = [
    {
      id: "litigation-details",
      title: "Litigation & Dispute Resolution",
      content:
        "We represent clients in civil, criminal, and commercial disputes. Our team is experienced in trial advocacy, mediation, arbitration, and public law litigation including judicial review and constitutional petitions.",
    },
    {
      id: "constitutional-details",
      title: "Constitutional & Human Rights Law",
      content:
        "We advocate for the protection of fundamental rights and freedoms, offering expertise in constitutional compliance, judicial enforcement of rights, and public interest litigation.",
    },
    {
      id: "labour-details",
      title: "Employment & Labour Relations",
      content:
        "We provide legal solutions for employment contracts, workplace disputes, terminations, trade union matters, and labor law compliance strategies for both employers and employees.",
    },
    {
      id: "realestate-details",
      title: "Real Estate & Conveyancing",
      content:
        "We handle property transactions, due diligence, leases, land transfers, subdivisions, and title processing to protect your real estate investments.",
    },
    {
      id: "corporate-details",
      title: "Corporate & Commercial Law",
      content:
        "From business incorporation to mergers and acquisitions, we advise on regulatory compliance, shareholder agreements, contracts, restructuring, and risk mitigation.",
    },
    {
      id: "banking-details",
      title: "Banking & Securities Law",
      content:
        "We assist lenders and borrowers with drafting loan agreements, registering securities, and ensuring regulatory compliance in financial transactions.",
    },
    {
      id: "ip-details",
      title: "Intellectual Property Law",
      content:
        "We protect innovation through registration of trademarks, copyrights, patents, and provide legal strategies for brand enforcement and IP commercialization.",
    },
    {
      id: "environment-details",
      title: "Environment & Land Law",
      content:
        "Our services include handling environmental compliance, land use planning, conservation advocacy, zoning disputes, and environmental impact assessments.",
    },
    {
      id: "succession-details",
      title: "Succession, Wills & Trusts",
      content:
        "We assist with estate planning, wills, administration of estates, formation of trusts, and probate litigation to safeguard generational wealth.",
    },
  ];

  return (
    <section className="bg-white text-deepgreen px-6 py-24 border-t border-gray-100">
      <div className="max-w-6xl mx-auto space-y-20">
        <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-serif font-bold">In-Depth Expertise</h2>
            <div className="w-24 h-1 bg-gold mx-auto mt-4"></div>
        </div>

        {serviceDetails.map((service, index) => (
          <div 
            id={service.id} 
            key={service.id} 
            className={`scroll-mt-32 flex flex-col md:flex-row gap-8 md:gap-16 items-start ${index % 2 !== 0 ? 'md:flex-row-reverse' : ''}`}
            data-aos="fade-up"
          >
            <div className="md:w-1/3">
                <h3 className="text-2xl font-serif font-bold text-deepgreen mb-4 relative inline-block">
                    {service.title}
                    <span className="absolute -bottom-2 left-0 w-1/2 h-1 bg-gold"></span>
                </h3>
            </div>
            <div className="md:w-2/3">
                <p className="text-lg text-gray-700 leading-relaxed">{service.content}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServiceDetailsSection;
